import React from 'react';

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ eyebrow, title, description, actions }) => (
  <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
    <div className="min-w-0">
      {eyebrow && (
        <div className="flex items-center gap-2 mb-1.5">
          <span aria-hidden className="inline-block h-px w-6 bg-brand-accent" />
          <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-brand-accent">
            {eyebrow}
          </span>
        </div>
      )}
      <h2 className="text-2xl font-semibold tracking-tight text-brand-text leading-tight">
        {title}
      </h2>
      {description && (
        <p className="mt-1 text-sm text-brand-text-muted">{description}</p>
      )}
    </div>
    {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
  </div>
);

export default PageHeader;
